import React, { useState, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

import { activityHistoryViewReact } from "../../store/actions";

import {
  CoachingScreen,
  TaskFollowUpScreen,
  EvaluationScreen,
} from "../partialScreens/ActivityDetails";

const ActivityDetailsModal = ({ clickedRow, showModal, toggleModal }) => {
  const dispatch = useDispatch();
  const { activeOrganizationInfo, activityHistoryData, isActivityLoading } =
    useSelector(
      ({
        get_active_organization_detail: { data: activeOrganizationData },
        activity_history_view_react: {
          data: activityHistoryAllData,
          isFetching,
        },
      }) => {
        return {
          activeOrganizationInfo: activeOrganizationData || {},
          activityHistoryData: activityHistoryAllData,
          isActivityLoading: isFetching,
        };
      },
      shallowEqual,
    );
  useEffect(() => {
    if (!clickedRow || !activeOrganizationInfo) return;
    dispatch(
      activityHistoryViewReact({
        activityid: clickedRow?.activityid,
        companyguid: activeOrganizationInfo?.Companyguid,
        loogedinuser: activeOrganizationInfo?.LoginEmail,
        loginemptitle: activeOrganizationInfo?.LoginEmpTitle,
        employeeno: activeOrganizationInfo?.Employeeid,
        titlerolename: activeOrganizationInfo?.titlerolename || "L1",
        id: clickedRow?.id,
        varcharemployeeid: activeOrganizationInfo?.Employeeid,
        username: activeOrganizationInfo?.UserName,
      }),
    );
  }, [dispatch, clickedRow, activeOrganizationInfo]);

  const PropsConfig = {
    toggleModal: toggleModal,
    actionModule: clickedRow?.actionmodule,
    activeOrganizationInfo: activeOrganizationInfo,
    activityHistoryAllInfo: activityHistoryData,
    isFetching: isActivityLoading,
  };

  const modalScreens = {
    Coaching: (
      <CoachingScreen
        {...PropsConfig}
        activityHistoryInfo={activityHistoryData}
      />
    ),
    "Task & Follow Up": <TaskFollowUpScreen {...PropsConfig} />,
    "Task Recognition": <TaskFollowUpScreen {...PropsConfig} />,
    CTC: <CoachingScreen {...PropsConfig} />,
    evaluation_qa: <EvaluationScreen {...PropsConfig} />,
    evaluation: <EvaluationScreen {...PropsConfig} />,
    Agent_Dashboard: <CoachingScreen {...PropsConfig} />,
    Game: <CoachingScreen {...PropsConfig} />,
    // 4: <CoachingScreen {...PropsConfig} />,
  };
  return (
    <Modal
      isOpen={showModal}
      toggle={toggleModal}
      //   className={className}
      backdrop={true}
      keyboard={true}
      id="viewcoach"
      style={{
        maxWidth: "95%",
      }}
    >
      {modalScreens[clickedRow?.actionmodule]}
    </Modal>
  );
};
export default ActivityDetailsModal;
